import { render, staticRenderFns } from "./address.popup.vue?vue&type=template&id=1216cf2d&scoped=true&"
import script from "./address.popup.vue?vue&type=script&lang=js&"
export * from "./address.popup.vue?vue&type=script&lang=js&"
import style0 from "./address.popup.vue?vue&type=style&index=0&id=1216cf2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1216cf2d",
  null
  
)

export default component.exports